
import './Header.css';
import { Container } from 'reactstrap';
import React from 'react';
import { NavLink , Link } from 'react-router-dom';
import { useState, useEffect ,useRef } from 'react';


function  Header () {

    const  headerRef  = useRef(null);

    const menuRef = useRef(null);

    useEffect(() => {
        window.addEventListener('scroll' ,() => {
            if ( document.body.scrollTop  > 80 || document.documentElement.scrollTop > 80  ) {
                headerRef.current.classList.add('header__shrink')
            } 
            else {
                headerRef.current.classList.remove('header__shrink');
            } 
        });

        // return () => {
        //     window.removeEventListener("scroll");
        // };

    } , []);

    const NAV__LINKS = [
        {
            display: "Home",
            url: "/home"
        },
        {
            display: "Market",
            url: "/market"
        },
        {
            display: "Create",
            url: "/create"
        },
        {
            display: "Contact",
            url: "/contact"
        }
    ];

    const  toggleMenu = () =>  menuRef.current.classList.toggle('active__menu');

    return(
        <header className='header'  ref={headerRef}>
            <Container>
                <div className='navigation'>
                    <div className='logo'>
                        <h2 className='d-flex gap-2  align-items-center'> 
                            <span> 
                                <i className="ri-fire-fill"></i> 
                            </span> 
                            NFTs 
                        </h2>
                    </div>


                    <div className='nav__menu'  ref={menuRef}   onClick={toggleMenu}   >
                        <ul  className='nav__list'  style={{color:"white"}}>
                            {
                                NAV__LINKS.map(( item , index  ) => {
                                    return(
                                        <li  className='nav__item'  key={index}>
                                            <NavLink  to={item.url}  className={(navClass) => navClass.isActive ? "active" : ""}>  
                                                {item.display} 
                                            </NavLink>
                                            
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </div>

                    <div className='nav__right  d-flex  align-items-center  gap-5  ' >
                        <button  className='btn d-flex  gap-2  align-items-center   '>  
                            <span>
                                <i class="ri-wallet-line"></i>
                            </span>
                            <Link  to='wallet'  className=''>
            
                                Connect Wallet
                            </Link>
                        </button>

                        <span  className='mobile__menu'  >  <i class="ri-menu-4-line"   onClick={toggleMenu}></i>  </span>

                    </div>







                </div>
            </Container>
        </header>
    );
}


export  default  Header;